import FilterPopover from 'components/FilterPopover';
import FilterButton from 'components/FilterPopover/FilterButton';
import React, { useState, useContext } from 'react';
import { Manager } from 'react-popper';
import { SubmittalFilter } from 'records/SubmittalFilter';
import { SubmittalQuery } from 'records/SubmittalQuery';
import querySubmittals from 'utils/querySubmittals';
import withAppStore from 'utils/withAppStore';
import AppStoreContext from 'contexts/AppStoreContext';
import { useTranslator } from '@bluebeam/react-i18n';
import CategoriesFilterSection from './CategoriesFilterSection';
import StatusFilterSection from './StatusFilterSection';

const SubmittalsFilterPopover = () => {
  const { state: appState, actions } = useContext(AppStoreContext);
  const [open, setOpen] = useState<boolean>(false);
  const [submittalQuery, setSubmittalQuery] = useState<SubmittalQuery>(
    appState.submittalQuery
  );
  const { translate } = useTranslator(['filters']);

  const getAppState = (): SubmittalFilter => {
    const { submittals } = appState;

    const appData = new SubmittalFilter({
      submittalQuery,
      submittals,
    });

    return appData;
  };

  const handleFilterClick = (): void => {
    const { submittalQuery } = getAppState();
    setOpen(true);
    setSubmittalQuery(submittalQuery);
  };

  const handleCloseClick = (): void => {
    setOpen(false);
  };

  const handleResetClick = async (): Promise<void> => {
    const resetSubmitalQuery = submittalQuery
      .delete('statuses')
      .delete('categories');

    setSubmittalQuery(resetSubmitalQuery);
  };

  const handleFilterConfirm = (): void => {
    const { submittalQuery } = getAppState();

    actions.setSubmittalQuery(submittalQuery);
    setOpen(false);
  };

  const getFilterApplied = (): boolean => {
    const { submittalQuery } = getAppState();

    return (
      submittalQuery.statuses.size > 0 || submittalQuery.categories.size > 0
    );
  };

  const getConfirmBtnText = (): string => {
    const { submittalQuery, submittals } = getAppState();

    const qs = querySubmittals(submittals, submittalQuery);

    if (qs.size === submittals.size) {
      return translate('filters:showAllItems');
    }

    return `${translate('filters:showAllItems')} ${qs.size} ${
      qs.size !== 1 ? translate('filters:items') : translate('filters:item')
    }`;
  };

  const handlerUpdateLocalSubQuery = (nextSubQuery: SubmittalQuery) => {
    setSubmittalQuery(nextSubQuery);
  };

  return (
    <Manager>
      <FilterButton
        onFilterClick={handleFilterClick}
        filterApplied={getFilterApplied()}
      />
      <FilterPopover
        title={translate('filters:filters')}
        open={open}
        onClose={handleCloseClick}
        onReset={handleResetClick}
        onConfirm={handleFilterConfirm}
        confirmBtnText={getConfirmBtnText()}
      >
        <StatusFilterSection
          submittalQuery={submittalQuery}
          updateSubmittalQuery={handlerUpdateLocalSubQuery}
        />
        <CategoriesFilterSection
          submittalQuery={submittalQuery}
          updateSubmittalQuery={handlerUpdateLocalSubQuery}
        />
      </FilterPopover>
    </Manager>
  );
};

export default withAppStore(SubmittalsFilterPopover);
